import React, { Component } from 'react'
import 'react-dates/initialize'
import ScrollMemory from 'react-router-scroll-memory'
import PropTypes from 'prop-types'
import { BrowserRouter,Switch } from 'react-router-dom'
import { connect } from 'react-redux'
import {find} from 'lodash/find'
import {showLiveViewAlertModal } from '../actions/modals'
import { authenticate, unauthenticate,logout } from '../actions/session'
import {pusherPollReceived} from '../actions/polls'
import {controlReceived} from '../actions/control'
import {sectionControlReceived} from '../actions/sectionControl'
import {loadInitialData} from '../actions/initialData'
import {onboardingStatusUpdateRecieved} from '../actions/meta'
import {fetchSearchKey} from '../actions/searchKey'
import {resendEmailConfirmation} from '../actions/user'
import TrashContainer from './TrashContainer'
import ModalContainer from './modals/ModalContainer'
import HistoryContainer from './HistoryContainer'

import AccountContainer from './account/AccountContainer'

import QuestionPollDetailContainer from './pollDetail/QuestionPollDetailContainer'
import SetPollDetailContainer from './pollDetail/SetPollDetailContainer'
import SetPollPollDetailContainer from './pollDetail/SetPollPollDetailContainer'
import SetDetailContainer from './itemDetail/SetDetailContainer'
import SetQuestionDetailContainer from './itemDetail/SetQuestionDetailContainer'
import QuestionDetailContainer from './itemDetail/QuestionDetailContainer'
import SearchResultsContainer from './search/SearchResultsContainer'
import FloatingNPControlContainer from './liveView/FloatingNPControlContainer'
import NotificationContainer from './NotificationContainer'
import TopNavContainer from './navigation/TopNavContainer'
import SideNavContainer from './navigation/SideNavContainer'
import LiveViewNotificationContainer from './liveView/LiveViewNotificationContainer'
// import WhatsNewContainer from './WhatsNewContainer'
import BackToSchoolModalContainer from './BackToSchoolModalContainer'
// import OnboardingContainer from './onboarding/OnboardingContainer'
import LiveViewModalContainer from './liveView/LiveViewModalContainer'

import UpgradeContainer from './upgrade/UpgradeContainer'
import ConfirmEmailContainer from './sessions/ConfirmEmailContainer'
import ReleaseNotesContainer from './ReleaseNotesContainer'
import RepoContainer from './repo/RepoContainer'
import RepoTrashContainer from './repo/RepoTrashContainer'

import OnboardingWizardContainer from './onboarding/OnboardingWizardContainer'
import RepoReleaseModalContainer from './RepoReleaseModalContainer'

import IsbeDomainMatchContainer from './IsbeDomainMatchContainer'


// import DnDTestContainer from './DnDTestContainer'

//routing components
/*
 Redirect components check the authentication props and conditionally render <MATCH/> or  </REDIRECT>.
 willAuthenticate prop is used to prevent component redirecting while user is being authenticated
 with the API
 */

import MatchAuthenticated from '../components/routing/MatchAuthenticated'
import RedirectAuthenticated from '../components/routing/RedirectAuthenticated'
import MatchRootAuthenticated from '../components/routing/MatchRootAuthenticated'
import LastLocationProvider from '../components/routing/LastLocationProvider'
import RedirectInvalidUrl from '../components/routing/RedirectInvalidUrl'

import ImportQuestionsHelperContainer from './importQuestions/ImportQuestionsHelperContainer'


  
import {appPusherSetup} from '../utils/pusher/appPusherSetup'

  
		
 


//sentry
// import Raven from 'raven-js'
// import {logException} from '../sentryConfig.js'

//Raven.config(sentry_url).install()
// Raven.captureMessage('Test Raven Capture Message')
// Raven.showReportDialog()
// logException(new Error('testing sentry log exception'),{
//   email:'nicole@iscool.com'

// })

import {checkForExpiredLocks} from '../actions/locks'


import { DragDropContextProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'


import {StripeProvider} from 'react-stripe-elements'

// import Loadable from 'react-loadable'
// import SetEditorLoadingPage from '../components/loading/SetEditorLoadingPage'

// const DEV_STRIPE_KEY='pk_test_Q9V8n4my9X38dkWHaZPrSxtW'

import Loadable from 'react-loadable'
import ReactGA from 'react-ga'
import * as Sentry from '@sentry/browser'

if(process.env.REACT_APP_ENV==='production' ){
	ReactGA.initialize(process.env.REACT_APP_GA_TRACKING_ID)
	// Raven.config(process.env.REACT_APP_SENTRY_URL).install()
	Sentry.init({ dsn: `${process.env.REACT_APP_SENTRY_URL}`})
}

if(process.env.REACT_APP_ENV!=='production'){
	Sentry.init({ dsn: `${process.env.REACT_APP_SENTRY_URL}` })
}



const Login = Loadable({
	loader: () => import('./sessions/LoginContainer'),
	loading() {
		return null
	}
})
const Signup = Loadable({
	loader: () => import('./sessions/SignupContainer'),
	loading() {
		return null
	}
})

const ForgotPasswordContainer = Loadable({
	loader: () => import('./sessions/ForgotPasswordContainer'),
	loading() {
		return null
	}
})

const ResetPasswordContainer = Loadable({
	loader: () => import('./sessions/ResetPasswordContainer'),
	loading() {
		return null
	}
})

const ScoreSheetContainer = Loadable({
	loader: () => import('./scoreSheet/ScoreSheetContainer'),
	loading() {
		return null
	}
})

const SectionRosterContainer = Loadable({
	loader: () => import('./sections/SectionRosterContainer'),
	loading() {
		return null
	}
})

const SetEditorContainer = Loadable({
	loader: () => import('./editors/SetEditorContainer'),
	loading() {
		return null
	}
})

const QuestionEditorContainer = Loadable({
	loader: () => import('./editors/QuestionEditorContainer'),
	loading() {
		return null
	}
})


const LibraryContainer = Loadable({
	loader: () => import('./LibraryContainer'),
	loading() {
		return null
	}
})

const SectionContainer = Loadable({
	loader: () => import('./sections/SectionContainer'),
	loading() {
		return null
	}
})
const RecentContainer = Loadable({
	loader: () => import('./RecentContainer'),
	loading() {
		return null
	}
})

const ScanHelperContainer = Loadable({
	loader: () => import('./scanHelper/ScanHelperContainer'),
	loading() {
		return null
	}
})




// import LibraryContainer from './LibraryContainer'


//containers
//import Login from './sessions/LoginContainer'
// // import Signup from './sessions/SignupContainer'

// import ForgotPasswordContainer from './sessions/ForgotPasswordContainer'
// import ResetPasswordContainer from './sessions/ResetPasswordContainer'



// const LoadableSetEditorContainer = Loadable({
// 	import('./editors/SetEditorContainer')
// })







class AppContainer extends Component {

	
	constructor() {
		super()
		this.handlePageScroll = this.handlePageScroll.bind(this)
		this.findSidePanel = this.findSidePanel.bind(this)
		this.registerStickyHeader = this.registerStickyHeader.bind(this)
		this.unregisterStickyHeader = this.unregisterStickyHeader.bind(this)
		this.unregisterTopHeader = this.unregisterTopHeader.bind(this)
		this.registerTopHeader = this.registerTopHeader.bind(this)
		this.unregisterSidePanel = this.unregisterSidePanel.bind(this)
		this.registerSidePanel = this.registerSidePanel.bind(this)
		this.pusherSetupSucessful = this.pusherSetupSucessful.bind(this)


		this.stickyHeader = {}
		this.topHeader = {}
		this.sidePanels = []
		this.state = {
			subscribedToPusher: false,
			resentEmail:false,
			stripe: null
		}




		// if (process.env.NODE_ENV !== 'production') {
		//   const {whyDidYouUpdate} = require('why-did-you-update')
		// 	  whyDidYouUpdate(React, { include: /^Recent/})
		// 	// whyDidYouUpdate(React, { groupByComponent: true, collapseComponentGroups: false })
		// }

	} 





	UNSAFE_componentWillMount() {
		const session = JSON.parse(localStorage.getItem('ls.session'))
		if (session) {
			(this.props.authenticate(session.token)).then(() => {
		    this.props.loadInitialData(this.props.session.sessionInfo.user)
		    appPusherSetup(this.props.session.sessionInfo.user,this.pusherSetupSucessful)
			})
		} else {
			this.props.unauthenticate()
		}
	}
	
	pusherSetupSucessful(){
		this.setState({subscribedToPusher:true})
	}


	componentDidMount() {
		this.interval = setInterval(() => this.props.checkForExpiredLocks(), 10000)


		if(process.env.REACT_APP_ENV !=='production'){
			console.log('********************')
			console.log(process.env.REACT_APP_ENV)
			console.log('********************')
		}
		SectionContainer.preload()
		LibraryContainer.preload()
		RecentContainer.preload()
		window.addEventListener('scroll', this.handlePageScroll)
    	if (window.Stripe) {
      		this.setState({stripe: window.Stripe(process.env.REACT_APP_PLICKERS_STRIPE_TOKEN)})
    	} else {
      		document.querySelector('#stripe-js').addEventListener('load', () => {
        	// Create Stripe instance once Stripe.js loads
        	this.setState({stripe: window.Stripe(process.env.REACT_APP_PLICKERS_STRIPE_TOKEN)})
      	})
 	 }

	}

	UNSAFE_componentWillReceiveProps(nextProps) {
 		if(!this.state.subscribedToPusher && nextProps.session.sessionInfo && nextProps.session.sessionInfo.user){
 			//this.pusherSetup(nextProps.session.sessionInfo.user)
 			appPusherSetup(nextProps.session.sessionInfo.user,this.pusherSetupSucessful)
 		}
 	}

	componentWillUnmount(){
		window.removeEventListener('scroll', this.handlePageScroll)
		clearInterval(this.interval)
	}




	getChildContext() {
		return {
			registerStickyHeader: this.registerStickyHeader,
			unregisterStickyHeader: this.unregisterStickyHeader,
			registerTopHeader: this.registerTopHeader,
			unregisterTopHeader: this.unregisterTopHeader,
			registerSidePanel: this.registerSidePanel,
			unregisterSidePanel: this.unregisterSidePanel
		}
	}

	

	findSidePanel(node) {
		return find(this.sidePanels,function (panel) {
			return panel === node
		})
	}



	registerStickyHeader(node,height){
		this.stickyHeader={node:node,height:height}
	}

	registerTopHeader(node,height){
		this.topHeader={node:node,height:height}
	}


	registerSidePanel(node){
		if (!this.findSidePanel(node)) {
			this.sidePanels.push(node)
		}
	}

	

	unregisterStickyHeader(){
		this.stickyHeader={}	
	}
	

	unregisterTopHeader(){
		this.topHeader={}
	}
	

	unregisterSidePanel(node){
		if (this.findSidePanel(node)) {
			this.sidePanels.splice(this.sidePanels.indexOf(node), 1)
		}
	}



	//attach to scroll event on relevant page elements
	handlePageScroll(){
		const scrollAmount = window.pageYOffset	
		const scrollTransitionBuffer = 20
		const showStickyScrollPosition = this.topHeader.height - this.stickyHeader.height - scrollTransitionBuffer		
		
		let stickyDisplay

		if(scrollAmount > showStickyScrollPosition){			
			stickyDisplay = 'flex'
		}
		else {
			stickyDisplay = 'none'
		}		
		if(this.stickyHeader.node){
			this.stickyHeader.node.style.display = stickyDisplay		
		}
	}





	// pusherSetup(userId) {
	// 	Pusher.logToConsole = true //for dev
	// 	var pusher = new Pusher(process.env.REACT_APP_PLICKERS_PUSHER_TOKEN, {
	// 		encrypted: true
	// 	})
	// 	// const userId = this.props.session.sessionInfo.user
	// 	var channel = pusher.subscribe(userId)
		
	// 	//channel.bind('control-update', this.recievePusher)
	// 	channel.bind('control-update', this.recievePusher)//Temp switch back to control event for prod
		
	// 	channel.bind('response-update', this.recievePusherPoll)
	// 	channel.bind('onboarding-status-update', this.receiveOnbordingStatusUpdate)
	// 	channel.bind('section-control', this.receiveSectionControlUpdate)
	// 	channel.bind('repo added', this.props.fetchSearchKey)
	// 	channel.bind('repo removed', this.props.fetchSearchKey)
		
	// 	// this.setState({
	// 	// 	subscribedToPusher: true
	// 	// })
	// }
 

	// recievePusher(data) {
	// 	this.props.controlReceived(data.message)
	// }
	// receiveSectionControlUpdate(data){
	// 	this.props.sectionControlReceived(data)
	// }

	// recievePusherPoll(data) {
	// 	this.props.pusherPollReceived(data)
	// }

	// receiveOnbordingStatusUpdate(data){
	// 	this.props.onboardingStatusUpdateRecieved(data.status)
	// }

  
	render() {
		const { isAuthenticated, willAuthenticate } = this.props
		const authProps = { isAuthenticated, willAuthenticate }
		const loginProps = {isAuthenticated, willAuthenticate}


		return (	
			<DragDropContextProvider backend={HTML5Backend}>
			<React.Fragment>
			<BrowserRouter scrollBehaviour={'auto'} >
				<StripeProvider stripe={this.state.stripe}>
				  <LastLocationProvider>
						<div className='App' id='App' >

						 	<ScrollMemory />
							<ModalContainer />

							<NotificationContainer/>
							<UpgradeContainer/>




							{isAuthenticated  && 
								<BackToSchoolModalContainer/>
							}

								
							{isAuthenticated  && 
								<IsbeDomainMatchContainer/>
							}


							
							{isAuthenticated  && 
								<RepoReleaseModalContainer/>
							}

				
							
						
							<OnboardingWizardContainer/>
							
	 	
							 
							{isAuthenticated  && 
									<TopNavContainer/>
							}				

							
							{isAuthenticated  && 
								<LiveViewNotificationContainer />
							}
												

							{isAuthenticated  && 
									<FloatingNPControlContainer />
							}


							{isAuthenticated &&
								<ReleaseNotesContainer />
							}


							{isAuthenticated  &&						
								<div className="sideNavContainer sideNavContainer--default">
									<SideNavContainer />

								</div>
							}	
									
							<Switch>
								<RedirectAuthenticated path='/login' component={Login} {...loginProps}/>
								<RedirectAuthenticated path='/signup' component={Signup} {...authProps} />
								<RedirectAuthenticated path='/forgot-password' component={ForgotPasswordContainer} {...authProps} />
								<RedirectAuthenticated path='/reset-password' component={ResetPasswordContainer} {...authProps} />
								<MatchAuthenticated path='/reports' component={HistoryContainer} {...authProps} />
								<MatchAuthenticated path='/recent' component={RecentContainer} {...authProps} />
								<MatchAuthenticated path='/library/:folderId?' title='library'  component={LibraryContainer} {...authProps}  />
								<MatchAuthenticated path='/trash' title='trash'  component={TrashContainer} {...authProps}  />
								<MatchAuthenticated path='/scoresheet' component={ScoreSheetContainer} {...authProps} />
								<MatchAuthenticated path='/nowPlaying' component={RecentContainer} {...authProps} />
								<MatchAuthenticated path='/account' component={AccountContainer} {...authProps}/>				
								<MatchAuthenticated path='/setreport/:pollId/:pollPollId' component={SetPollPollDetailContainer} {...authProps} />
								<MatchAuthenticated path='/setreport/:pollId' component={SetPollDetailContainer} {...authProps}  />
								<MatchAuthenticated path='/questionreport/:pollId' component={QuestionPollDetailContainer} {...authProps} />							
								<MatchAuthenticated path='/classes/:id/:sectionNav' component={SectionContainer} {...authProps}  />		
								<MatchAuthenticated path='/classes/:id/' component={SectionContainer} {...authProps}  />				
								<MatchAuthenticated path='/classRoster/:id' component={SectionRosterContainer} {...authProps} />
								<MatchAuthenticated path='/seteditor/:id' component={SetEditorContainer} {...authProps} />
								<MatchAuthenticated path='/editor/:id' component={QuestionEditorContainer} {...authProps} />								
								<MatchAuthenticated path='/set/:id/:questionId' component={SetQuestionDetailContainer} {...authProps} />
								<MatchAuthenticated path='/set/:id' component={SetDetailContainer} {...authProps} />
								<MatchAuthenticated path='/packs/:id/trash' component={RepoTrashContainer} {...authProps} />
								<MatchAuthenticated path='/packs/:id/:folderId?' component={RepoContainer} {...authProps} />
								

								<MatchAuthenticated path='/question/:id' component={QuestionDetailContainer} {...authProps} />
								<MatchAuthenticated path='/searchresults/' component={SearchResultsContainer} {...authProps} />	
								<MatchAuthenticated path='/confirm-email' component={ConfirmEmailContainer} {...authProps} />	
								<MatchAuthenticated path='/scan-helper' component={ScanHelperContainer} {...authProps} />	
								<MatchAuthenticated path='/import-questions-helper' component={ImportQuestionsHelperContainer} {...authProps} />	

								<MatchAuthenticated path='/claim' component={LibraryContainer} {...authProps} />

								<MatchRootAuthenticated exact path='/' component={RecentContainer} {...authProps} />	
								<RedirectInvalidUrl {...authProps} />					
							</Switch>

							{isAuthenticated  && 
								<LiveViewModalContainer/>
							}



						</div>	
				  </LastLocationProvider>
			  	</StripeProvider>
			</BrowserRouter>	

			</React.Fragment>
			
			</DragDropContextProvider>	
		)
	}
}

export default connect(
	(state,ownProps) => ({
		isAuthenticated: state.session.isAuthenticated,
		willAuthenticate: state.session.willAuthenticate,
		currentUser:state.user,
		sections:state.sections,
		session:state.session,
		meta:state.meta,
		control:state.control
	}),
	{ 
		authenticate, 
		unauthenticate,
		logout,
		showLiveViewAlertModal,
		controlReceived,
		pusherPollReceived,
		loadInitialData,
		resendEmailConfirmation,
		onboardingStatusUpdateRecieved,
		sectionControlReceived,
		checkForExpiredLocks,
		fetchSearchKey

	}
)(AppContainer)


AppContainer.childContextTypes = {
	location: PropTypes.object,
	registerStickyHeader: PropTypes.func,
	unregisterStickyHeader: PropTypes.func,
	registerTopHeader: PropTypes.func,
	unregisterTopHeader: PropTypes.func,
	registerSidePanel: PropTypes.func,
	unregisterSidePanel: PropTypes.func,
}





// WEBPACK FOOTER //
// ./src/containers/AppContainer.js